import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  data: [],
  loading: false,
  byProfessional: {}, // uid -> entrada de uso (para a saúde do card de pós-vendas)
  entitlements: {}, // uid -> { ai, aiRecorder, tv, twilio, updatedAt } (módulos ligados)
  entitlementsLoading: false,
  accounts: [], // contas criadas no intervalo pedido (acompanhamento)
  accountsMeta: null, // { since, until, generatedAt, authUsers } do último fetch
  accountsLoading: false,
  accountsError: false,
  accountAppointments: {}, // uid -> { confirmed, canceled, last30d, lastTime, agendas }
  accountAppointmentsLoading: false,
  accountAppointmentsError: false,
};

export default function usageReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return { ...initState };

    case actions.FETCHING_USAGE:
      return { ...state, loading: true };
    case actions.FETCH_USAGE_SUCCESS:
      return { ...state, data: action.payload, loading: false };
    case actions.FETCH_USAGE_ERROR:
      return { ...state, data: [], loading: false };

    case actions.FETCHING_ENTITLEMENTS:
      return { ...state, entitlementsLoading: true };
    case actions.FETCH_ENTITLEMENTS_SUCCESS:
      return { ...state, entitlements: action.payload, entitlementsLoading: false };
    case actions.FETCH_ENTITLEMENTS_ERROR:
      return { ...state, entitlements: {}, entitlementsLoading: false };

    case actions.FETCHING_ACCOUNTS:
      return { ...state, accountsLoading: true, accountsError: false };
    case actions.FETCH_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: action.payload.accounts || [],
        accountsMeta: {
          since: action.payload.since,
          until: action.payload.until,
          generatedAt: action.payload.generatedAt,
          authUsers: action.payload.authUsers,
        },
        accountsLoading: false,
        accountsError: false,
      };
    case actions.FETCH_ACCOUNTS_ERROR:
      return { ...state, accountsLoading: false, accountsError: true };

    case actions.FETCHING_ACCOUNT_APPOINTMENTS:
      return {
        ...state,
        accountAppointments: {},
        accountAppointmentsLoading: true,
        accountAppointmentsError: false,
      };
    case actions.FETCH_ACCOUNT_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        accountAppointments: { ...state.accountAppointments, ...action.payload },
      };
    case actions.FETCH_ACCOUNT_APPOINTMENTS_ERROR:
      return { ...state, accountAppointmentsError: true };
    case actions.FETCH_ACCOUNT_APPOINTMENTS_DONE:
      return { ...state, accountAppointmentsLoading: false };

    case actions.FETCH_PROFESSIONAL_USAGE_SUCCESS:
      return {
        ...state,
        byProfessional: {
          ...state.byProfessional,
          [action.payload.uid]: action.payload.usage,
        },
      };

    default:
      return state;
  }
}
